import React, {useState, useEffect, useRef} from "react";
import useOnClickOutside from "../hooks/useOnClickOutside";

const NavigationMenu = props => {
    const {parent, visible, callback, menuWidget = false} = props;
    const [menuHeight, setMenuHeight] = useState(undefined);
    const menuRef = useRef();

    useOnClickOutside(menuRef, visible, (event) => {
        const menuAncestor = menuRef.current.closest('.ch-nav-icon-btn');
        const eventAncestor = event.target.closest('.ch-nav-icon-btn');
        if (menuAncestor && menuAncestor !== eventAncestor) {
            if (callback && typeof callback === 'function') callback();
        }
    });

    useEffect(() => {
        if (!visible) setMenuHeight(undefined);
        else if (!menuHeight) setMenuHeight(menuRef.current.offsetHeight);
        if (menuHeight !== undefined) {
            const resizeListener = (e) => {
                let menuRect = menuRef.current.getBoundingClientRect(),
                    maxHeight = window.innerHeight - menuRect.top - 16;
                if (menuHeight > maxHeight) {
                    menuRef.current.style.height = maxHeight + 'px';
                } else {
                    menuRef.current.style.removeProperty('height');
                }
            };
            const keyListener = (e) => {
                if (visible && (e.key === 'Escape' || e.key === 'ArrowLeft')) {
                    parent.focus();
                    if (callback && typeof callback === 'function') callback();
                }
                if (!visible) window.dispatchEvent(new Event('resize'));
            }
            window.addEventListener('resize', resizeListener);
            window.dispatchEvent(new Event('resize'));
            window.addEventListener('keydown', keyListener);
            return () => {
                window.removeEventListener('resize', resizeListener);
                window.removeEventListener('keydown', keyListener);
            }
        }
    });

    const blurListener = event => {
        if (!menuRef.current?.contains(event.relatedTarget) && typeof callback === 'function') {
            callback();
        }
    }

    return (
        <div className={'ch-nav-menu' + (visible ? ' ch-nav-menu-visible' : '') + ' ch-nav-group'}>
            <div ref={menuRef} className={(menuWidget ? 'ch-menuWidget' : 'ch-nav-menu-inner')} onBlur={blurListener}>
                {props.children}
            </div>
            <div className={'ch-nav-menu-arrow'}>
                <div className={'ch-nav-arrow-inner'}></div>
            </div>
        </div>
    )
}

export default NavigationMenu